function resolveConfig(root) {
    return {
        baseUrl: root?.dataset?.apiBase || root?.dataset?.baseUrl || 'https://api.dwellow.co.uk',
        days: Number.parseInt(root?.dataset?.days || '30', 10) || 30,
        minimumCount: Number.parseInt(root?.dataset?.minimumCount || '1', 10) || 1
    };
}

function formatCount(value) {
    const count = Number(value);
    if (!Number.isFinite(count)) return '';
    const rounded = Math.floor(Math.max(0, count) / 10) * 10;
    return `${new Intl.NumberFormat('en-GB').format(rounded)}+`;
}

function buildErrorMessage(err, fallback) {
    return err?.message || fallback;
}

export function registerAshpSocialProof() {
    if (typeof document === 'undefined') return;

    const createStore = () => ({
        initialized: false,
        loading: true,
        error: null,
        count: null,
        periodDays: 30,
        minimumCount: 1,
        generatedAt: null,
        baseUrl: 'https://api.dwellow.co.uk',

        init() {
            if (this.initialized) return;
            this.initialized = true;
            const config = resolveConfig(this.$root);
            this.baseUrl = config.baseUrl;
            this.periodDays = config.days;
            this.minimumCount = config.minimumCount;
            this.load();
        },

        async load() {
            this.loading = true;
            this.error = null;
            try {
                const url = new URL('/ashp_social_proof', this.baseUrl);
                url.searchParams.set('days', String(this.periodDays));
                const response = await fetch(url.toString(), {
                    method: 'GET',
                    headers: { 'Accept': 'application/json' }
                });
                const data = await response.json().catch(() => null);
                if (!response.ok || !data?.ok || data.available === false) {
                    throw new Error(data?.error || `social_proof_${response.status}`);
                }
                const count = Number(data.count);
                this.count = Number.isFinite(count) ? count : null;
                this.periodDays = Number.isFinite(Number(data.periodDays)) ? Number(data.periodDays) : this.periodDays;
                this.generatedAt = data.generatedAt || null;
            } catch (err) {
                this.count = null;
                this.error = buildErrorMessage(err, 'Unable to load social proof.');
            } finally {
                this.loading = false;
            }
        },

        get visible() {
            return !this.loading &&
                !this.error &&
                Number.isFinite(Number(this.count)) &&
                Number(this.count) >= this.minimumCount;
        },

        get formattedCount() {
            return formatCount(this.count);
        },

        get message() {
            if (!this.visible) return '';
            const period = this.periodDays === 30 ? 'past month' : `past ${this.periodDays} days`;
            return `Join ${this.formattedCount} homeowners who've already got their heat pump estimate in the ${period}.`;
        }
    });

    const initTree = () => {
        if (!window.Alpine || typeof window.Alpine.initTree !== 'function') return;
        document.querySelectorAll('[data-journey="ashp-social-proof"]').forEach(root => {
            window.Alpine.initTree(root);
        });
    };

    const register = () => {
        if (!window.Alpine || typeof window.Alpine.data !== 'function') return;
        window.Alpine.data('ashpSocialProof', createStore);
        initTree();
    };

    if (window.Alpine) {
        register();
    } else {
        document.addEventListener('alpine:init', register);
    }
    document.addEventListener('DOMContentLoaded', initTree);
}

registerAshpSocialProof();
